import { createSelector } from 'reselect';

export const usersSelector = (state) => state.get('users');

export const usersByIdSelector = createSelector(usersSelector, (users) =>
  users.get('byId')
);

export const usersAllIdsSelector = createSelector(usersSelector, (users) =>
  users.get('allIds')
);

export const usersByProjectIdSelector = createSelector(usersSelector, (users) =>
  users.get('byProjectId')
);
